import { get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, FORM_FIELDS_TYPES, LOEWE_IMAGE_UPLOAD_FIELD_PROPS } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { InhaltTrenner } from 'src/pages/private/online-antrag/antrag-components/Wrapper';
import { getFormStrucWithoutComponentTable, mapindexbyPath } from 'src/utils/formStruc';
import { addIndexToPath, checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import { useApplication } from '../../../../../../../../context/ApplicationContext';
import PruefAssistenz from '../../../../../antrag-components/PruefAssistenz';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getTextFieldValidationByDatei } from 'src/lib/validation/fieldValidationHelper';
const P = AntragSchema.attributes;
const MAX_CHAR_LENGTH = 6000;

const AusgangssituationAntragLoewe: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Ausgangssituation_Pruefstatus.path}
				hinweisPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Ausgangssituation_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Ausgangssituation_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Ausgangssituation_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>

			<CreateForm
				formStruc={formStrucGegenwaertigerStand()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
			<InhaltTrenner marginBottom='2rem' />
			<CreateForm
				formStruc={formStrucNotwendigkeit()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
			<InhaltTrenner marginBottom='2rem' />
			<CreateForm
				formStruc={formStrucZielstellung()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
			<InhaltTrenner marginBottom='2rem' />

			<CreateForm
				formStruc={formStrucInnovation()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
			<InhaltTrenner marginBottom='2rem' />
			<CreateForm
				formStruc={formStrucKernkompetenz()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
		</>
	);
};

export default AusgangssituationAntragLoewe;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Ausgangssituation_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};

const formStrucGegenwaertigerStand = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Stand_Technik,
					maxCharLength: MAX_CHAR_LENGTH,
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Stand_Technik_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...LOEWE_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucNotwendigkeit = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Notwendigkeit_Einer_Neuartigen_Loesung,
					maxCharLength: MAX_CHAR_LENGTH,
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Notwendigkeit_Einer_Neuartigen_Loesung_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...LOEWE_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucZielstellung = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Zielstellung_Und_Anforderungsprofil,
					maxCharLength: MAX_CHAR_LENGTH,
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Zielstellung_Und_Anforderungsprofil_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...LOEWE_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucInnovation = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Innovationsgrad_Und_Alleinstellungsmerkmale,
					maxCharLength: MAX_CHAR_LENGTH,
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Innovationsgrad_Und_Alleinstellungsmerkmale_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...LOEWE_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucKernkompetenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Kernkompetenzen_Der_Verbundpartner,
					label: 'Darlegung der Kernkompetenzen der Verbundpartner (Ressourcen, Qualifikationen, Ausstattungen etc.)',
					maxCharLength: MAX_CHAR_LENGTH,
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Kernkompetenzen_Der_Verbundpartner_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...LOEWE_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const customFormStrucGegenwaertigerStand = (application: any, i: number) => {
	const datei = get(
		application,
		addIndexToPath(
			P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Stand_Technik_Bilder.schema.attributes.Bild.path,
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Stand_Technik_Bilder.path,
		),
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Stand_Technik_Bilder.schema.attributes.Bildunterschrift_Titel,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Stand_Technik_Bilder.schema.attributes.Copyright_Hinweise,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Stand_Technik_Bilder.schema.attributes.Kurzbeschreibung,
					validation: getTextFieldValidationByDatei(datei),
				},
			],
		},
	];
	return struc;
};

const customFormStrucNotwendigkeit = (application: any, i: number) => {
	const datei = get(
		application,
		addIndexToPath(
			P.Projektbeschreibung_Loewe.schema.attributes.Notwendigkeit_Einer_Neuartigen_Loesung_Bilder.schema.attributes.Bild.path,
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Notwendigkeit_Einer_Neuartigen_Loesung_Bilder.path,
		),
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Notwendigkeit_Einer_Neuartigen_Loesung_Bilder.schema.attributes
						.Bildunterschrift_Titel,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Notwendigkeit_Einer_Neuartigen_Loesung_Bilder.schema.attributes.Copyright_Hinweise,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Notwendigkeit_Einer_Neuartigen_Loesung_Bilder.schema.attributes.Kurzbeschreibung,
					validation: getTextFieldValidationByDatei(datei),
				},
			],
		},
	];
	return struc;
};

const customFormStrucZielstellung = (application: any, i: number) => {
	const datei = get(
		application,
		addIndexToPath(
			P.Projektbeschreibung_Loewe.schema.attributes.Zielstellung_Und_Anforderungsprofil_Bilder.schema.attributes.Bild.path,
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Zielstellung_Und_Anforderungsprofil_Bilder.path,
		),
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Zielstellung_Und_Anforderungsprofil_Bilder.schema.attributes.Bildunterschrift_Titel,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Zielstellung_Und_Anforderungsprofil_Bilder.schema.attributes.Copyright_Hinweise,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Zielstellung_Und_Anforderungsprofil_Bilder.schema.attributes.Kurzbeschreibung,
					validation: getTextFieldValidationByDatei(datei),
				},
			],
		},
	];
	return struc;
};

const customFormStrucInnovation = (application: any, i: number) => {
	const datei = get(
		application,
		addIndexToPath(
			P.Projektbeschreibung_Loewe.schema.attributes.Innovationsgrad_Und_Alleinstellungsmerkmale_Bilder.schema.attributes.Bild.path,
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Innovationsgrad_Und_Alleinstellungsmerkmale_Bilder.path,
		),
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Innovationsgrad_Und_Alleinstellungsmerkmale_Bilder.schema.attributes
						.Bildunterschrift_Titel,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Innovationsgrad_Und_Alleinstellungsmerkmale_Bilder.schema.attributes
						.Copyright_Hinweise,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Innovationsgrad_Und_Alleinstellungsmerkmale_Bilder.schema.attributes.Kurzbeschreibung,
					validation: getTextFieldValidationByDatei(datei),
				},
			],
		},
	];
	return struc;
};

const customFormStrucKernkompetenz = (application: any, i: number) => {
	const datei = get(
		application,
		addIndexToPath(
			P.Projektbeschreibung_Loewe.schema.attributes.Kernkompetenzen_Der_Verbundpartner_Bilder.schema.attributes.Bild.path,
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Kernkompetenzen_Der_Verbundpartner_Bilder.path,
		),
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Kernkompetenzen_Der_Verbundpartner_Bilder.schema.attributes.Bildunterschrift_Titel,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Kernkompetenzen_Der_Verbundpartner_Bilder.schema.attributes.Copyright_Hinweise,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Kernkompetenzen_Der_Verbundpartner_Bilder.schema.attributes.Kurzbeschreibung,
					validation: getTextFieldValidationByDatei(datei),
				},
			],
		},
	];
	return struc;
};
export const getFormStrucAusgangssituationAntragLoewe = (application: any) => {
	let result: FormStrucItem[] = [];
	const gegenwaertigerStandBilderLength = get(
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Stand_Technik_Bilder.path,
		[],
	).length;
	const notwendigkeitBilderLength = get(
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Notwendigkeit_Einer_Neuartigen_Loesung_Bilder.path,
		[],
	).length;
	const zielstellungBilderLength = get(
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Zielstellung_Und_Anforderungsprofil_Bilder.path,
		[],
	).length;
	const innovationBilderLength = get(
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Innovationsgrad_Und_Alleinstellungsmerkmale_Bilder.path,
		[],
	).length;
	const kernkompetenzBilderLength = get(
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Kernkompetenzen_Der_Verbundpartner_Bilder.path,
		[],
	).length;

	for (let i = 0; i < gegenwaertigerStandBilderLength; i++) {
		const customFormStrucWithIndex = mapindexbyPath(
			customFormStrucGegenwaertigerStand(application, i),
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Stand_Technik_Bilder,
		);
		result.push(...customFormStrucWithIndex);
	}

	for (let i = 0; i < notwendigkeitBilderLength; i++) {
		const customFormStrucWithIndex = mapindexbyPath(
			customFormStrucNotwendigkeit(application, i),
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Notwendigkeit_Einer_Neuartigen_Loesung_Bilder,
		);
		result.push(...customFormStrucWithIndex);
	}

	for (let i = 0; i < zielstellungBilderLength; i++) {
		const customFormStrucWithIndex = mapindexbyPath(
			customFormStrucZielstellung(application, i),
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Zielstellung_Und_Anforderungsprofil_Bilder,
		);
		result.push(...customFormStrucWithIndex);
	}

	for (let i = 0; i < innovationBilderLength; i++) {
		const customFormStrucWithIndex = mapindexbyPath(
			customFormStrucInnovation(application, i),
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Innovationsgrad_Und_Alleinstellungsmerkmale_Bilder,
		);
		result.push(...customFormStrucWithIndex);
	}

	for (let i = 0; i < kernkompetenzBilderLength; i++) {
		const customFormStrucWithIndex = mapindexbyPath(
			customFormStrucKernkompetenz(application, i),
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Kernkompetenzen_Der_Verbundpartner_Bilder,
		);
		result.push(...customFormStrucWithIndex);
	}

	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Ausgangssituation_Pruefstatus.path,
			P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Ausgangssituation_Erledigt.path,
		)
	) {
		result.push(...formStrucPruefAssistenz());
	}
	// concat with default formstruc without componentTable, or else componentTable path will overwrite customFormStruc validation
	result.push(...getFormStrucWithoutComponentTable(formStrucGegenwaertigerStand()));
	result.push(...getFormStrucWithoutComponentTable(formStrucNotwendigkeit()));
	result.push(...getFormStrucWithoutComponentTable(formStrucZielstellung()));
	result.push(...getFormStrucWithoutComponentTable(formStrucInnovation()));
	result.push(...getFormStrucWithoutComponentTable(formStrucKernkompetenz()));

	return result;
};
